import {useState} from 'react';
import {animated, useSpring} from '@react-spring/web';

export const AnimIncorrect = ({
    visible,
    duration = 50,
}: {
    visible: boolean;
    duration?: number;
}) => {
    const [length] = useState(85);

    const animatedStyle = useSpring({
        config: {duration},
        strokeDasharray: length,
        strokeDashoffset: visible ? 0 : length,
    });

    const animatedStyle2 = useSpring({
        config: {duration},
        delay: duration,
        strokeDasharray: length,
        strokeDashoffset: visible ? 0 : length,
    });

    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 130.2 130.2">
            <animated.line
                style={animatedStyle}
                className="path line"
                fill="none"
                stroke="#DC2626"
                strokeWidth="6"
                strokeLinecap="round"
                strokeMiterlimit="10"
                x1="95.8"
                y1="38"
                x2="34.4"
                y2="92.2"
                {...({} as any)} // Type assertion
            />
            <animated.line
                style={animatedStyle2}
                className="path line"
                fill="none"
                stroke="#DC2626"
                strokeWidth="6"
                strokeLinecap="round"
                strokeMiterlimit="10"
                x1="34.4"
                y1="37.9"
                x2="95.8"
                y2="92.3"
                {...({} as any)} // Type assertion
            />
        </svg>
    );
};
